/**
 * disable lint for now for this file,
 * since some of the logic inside will be refactored out from here from next PR.
 */
/* eslint-disable */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { CheckCircle, MoreVert } from '@material-ui/icons';
import AdditionalLocationMenuItems from '../location/AdditionalLocationMenuItems';

import {
  showTwoDecimalsForMoney,
} from '../../utils/Functions';
import {
  getLocations,
  getAdmin,
  getPageSettings,
} from '../../selectors';
import {
  displayResourceStyles,
  viewResourceStyles,
} from '../../css/style';
import DeleteConfirmDialog from '../share/DeleteConfirmDialog';
import LoadingBar from '../share/LoadingBar';
import {
  needsRemoveIntegrationPluBeforeDuplicate,
  rewardTypes,
  MAX_CHAR_TABLE_FIELD,
} from '../../data/Constants';
import * as CompanyFeatures from '../../services/CompanyFeatures';
import * as SharedOptions from '../../services/SharedOptions';
import {
  titleCase,
  translation,
} from '../../utils/Functions';
import {
  checkIsAuthorized,
  checkIsLocationAdmin,
} from '../../utils/AuthorizationChecks';
import cloneDeep from 'lodash/cloneDeep';
import flowRight from 'lodash/flowRight';
import get from 'lodash/get';
import { ViewMoreRow } from '../crud/DisplayResources/ViewMoreRow';

const styles = displayResourceStyles();
const viewStyles = viewResourceStyles();
class ResourceList extends Component {
  constructor(props) {
    super(props);
    const { data } = props;
    this.state = {
      anchorEl: null,
      isMenuOpen: data ? new Array(data.length) : [],
      isDeleteConfirmDialogOpen: false,
      dataInDeleteConfirmDialog: '',
    };
    this.prepareDisplayValuesMap = this.getPrepareDisplayValuesMap();
  }

  onClickEdit = (data, dataIndex) => {
    const {
      actions, match, history, resourceName, onClickEditResource,
    } = this.props;
    const { resource, resourceId } = match.params;
    actions.clearErrors();

    if (onClickEditResource && typeof onClickEditResource === 'function') {
      onClickEditResource(data.id);
      this.handleMenuClose(dataIndex);
      return;
    }
    if (resourceId) {
      history.push(`/${resource}/${resourceId}/${resourceName}/${data.id}/edit`);
    } else {
      history.push(`/${resourceName}/${data.id}/edit`);
    }
  }

  onClickDelete = async (data, index) => {
    this.setState({
      isDeleteConfirmDialogOpen: true,
      dataInDeleteConfirmDialog: data,
    });
    this.handleMenuClose(index);
  }

  /**
   * Can also duplicate non-shared options
   */
  handleDuplicateSharedOption = async (dataCopy, resourcePath) => {
    const { actions, apiToken, onClickDuplicateResource } = this.props;
    const {
      customizations,
      outOfStockLocations,
      price_add_on,
      sharedId,
      disabled,
      quantity,
      ...restOption
    } = dataCopy;
    const optionRes = await actions.addResource(apiToken, restOption, ...resourcePath);

    const newOption = get(optionRes, 'response');
    if (!newOption) return;
    const outOfStockResponse = await actions.updateResource(apiToken, outOfStockLocations, 'options', newOption.id, 'out-of-stock');
    const nextOOSLocationsToDisplay = cloneDeep(get(outOfStockResponse, 'response'));
    const setModifiersRequestsInfo = customizations.map(idNameObj => ({
      actionName: 'addResource',
      path: ['customizations', idNameObj.id, 'options'],
    }));
    const setModifiersArgs = {
      apiToken,
      option: newOption,
      selectedCustomizations: customizations,
      requestsInfo: setModifiersRequestsInfo,
      stayedSelectedsMap: {},
    };
    const newOptionWithModifiers = await actions.setModifiersOnOptions(setModifiersArgs);

    if (typeof onClickDuplicateResource === 'function') {
      const newOptionForDisplay = Object.assign({}, newOptionWithModifiers, { outOfStockLocations: nextOOSLocationsToDisplay });
      onClickDuplicateResource(newOptionForDisplay);
    }
  }

  /**
   * On click, make a duplicate of the selected resource
   */
  onClickDuplicate = (data, index) => {
    const {
      actions,
      admin,
      match,
      resourceName,
      apiToken,
      onClickDuplicateResource,
    } = this.props;
    const {
      resource,
      resourceId,
      subResource,
    } = match.params;
    let {
      id, image, hasWarning, ...dataCopy
    } = data;

    if (onClickDuplicateResource && typeof onClickDuplicateResource === 'function') {
      onClickDuplicateResource(data);
      this.handleMenuClose(index);
      return;
    }

    if (resource === 'products' || resourceName === 'products') {
      let resourcePath;
      if (resourceId) {
        resourcePath = [resource, resourceId, resourceName, id, 'duplicate'];
      } else {
        resourcePath = [resourceName, id, 'duplicate'];
      }
      actions.duplicateResource(apiToken, resourcePath).then((res) => {
        this.handleMenuClose(index);
      });
    } else if (subResource === 'catering-zones') {
      const resourcePath = [resource, resourceId, subResource, id, 'duplicate'];
      actions.duplicateResource(apiToken, resourcePath).then((res) => {
        this.handleMenuClose(index);
      });
      return;
    } else {
      // todo add api methods for other resources
      let subResourceName;
      let subResource;
      if (resourceName === 'products') {
        subResourceName = 'items';
        subResource = data.items;
        delete dataCopy.outOfStock;
        delete dataCopy.locations;
      } else if (resourceName === 'customizations') {
        subResourceName = 'options';
        subResource = data.options;
      }
      let resourcePath = [resourceName];
      if (resourceId) {
        resourcePath = [resource, resourceId, resourceName];
      }

      if (resourceName === 'coupons') {
        dataCopy.code = `Copy of ${dataCopy.code}`;
      } else {
        dataCopy.name = `Copy of ${dataCopy.name}`;
      }

      if (dataCopy.integrationPLU && needsRemoveIntegrationPluBeforeDuplicate.includes(resourceName)) {
        delete dataCopy.integrationPLU;
      }

      // The API endpoint for product creation automatially strips out any attached items you send
      if (resourceName === 'customizations' && dataCopy.options) {
        delete dataCopy.options;
      }
      if (resourceName === 'options' && dataCopy['out-of-stock']) {
        delete dataCopy['out-of-stock'];
      }

      const isSharedOptionsEnabled = CompanyFeatures.isSharedOptionsEnabled(admin);
      const isTopLevelOptions = resource === 'options';
      const isModifierOptionsTable = resource === 'customizations' && resourceName === 'options';
      if (isSharedOptionsEnabled && (isTopLevelOptions || isModifierOptionsTable)) {
        const path = ['options'];
        this.handleDuplicateSharedOption(dataCopy, path);
        return;
      }

      if (!isSharedOptionsEnabled && isModifierOptionsTable) {
        const cleanedOption = SharedOptions.cleanOptionsKeysForRequests(dataCopy);
        dataCopy = cleanedOption;
      }

      // Add copy of resource
      actions.addResource(apiToken, dataCopy, ...resourcePath).then((res) => {
        if (subResource) {
          subResource.map(async (item) => {
            const { id, ...itemCopy } = item;
            if (itemCopy.integrationPLU && needsRemoveIntegrationPluBeforeDuplicate.includes(subResourceName)) {
              delete itemCopy.integrationPLU;
            }
            if ((subResourceName === 'options' || subResourceName === 'items') && itemCopy['out-of-stock']) {
              delete itemCopy['out-of-stock'];
            }
            const resourceId = res.response.id;
            // Add subresource
            await actions.addResource(apiToken, itemCopy, resourceName, resourceId, subResourceName)
              .then((res) => {
                if (res.error) return;
                if (subResourceName !== 'items') return;
                const newItem = res.response;
                const customizations = item.customizations;
                const options = item.includedOptions;
                const mainPath = [resourceName, resourceId, subResourceName, newItem.id];
                actions.updateResource(apiToken, customizations, ...mainPath, 'customizations');
                actions.updateResource(apiToken, options, ...mainPath, 'includedOptions');
              });
          });
        }
        this.handleMenuClose(index);
      });
    }
  };

  /**
 * Returns a small table's props.resourceName over the match.params.subResource.
 *
 * Helps AuthorizationChecks.checkIsAuthorized distinguish between e.g. the small Customizations table in the Menu page,
 * and the Customizations-only page.
 *
 * Since it returns match.params.subResource, if you are on e.g. the /customizations page, and want to see if you are
 * authorized to see the 'Options' button in the three dots menu, then this function will not help, since 'options' is not yet
 * in match.params. In that case, get 'options' another way.
 */
  getRightSubResourceOrSmallTableParam = () => {
    const { resourceName, match } = this.props;
    const { resource, subResource } = match.params;
    return resource === 'menu' && smallTables.includes(resourceName) ? resourceName : subResource;
  }

  onClickRowSelection = (rowId, column) => {
    // user needs to click first column to view resource
    const {
      resourceName,
      match,
      history,
      admin,
      onClickEditResource,
    } = this.props;
    const { resource, resourceId, subResource } = match.params;
    if (!checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'edit')) return;
    if (typeof onClickEditResource === 'function') {
      onClickEditResource(rowId);
      return;
    }
    if (column === 0 || column === undefined) {
      if (resourceId) {
        history.push(`/${resource}/${resourceId}/${subResource}/${rowId}/edit`);
      } else {
        history.push(`/${resourceName}/${rowId}/edit`);
      }
    }
  }

  onClickCustomButton = (rowId, btnType) => {
    const { resourceName, history } = this.props;
    history.push(`/${resourceName}/${rowId}/${btnType}/`);
  };

  getDisplayAndExcessNames = (fieldData, displayNames = [], excessNames = [], authorized = false) => {
    let charLen = 0;
    const displayValues = fieldData.map((displayValue) => {
      if (!displayValue.name) return '';
      const displayValueName = displayValue.name;
      const val = !authorized ? displayValueName : displayValue;
      if (charLen + displayValueName.length < MAX_CHAR_TABLE_FIELD) {
        charLen += displayValueName.length;
        displayNames.push(val);
      } else {
        excessNames.push(displayValueName);
      }
      return val;
    });
    return displayValues;
  }

  getModifierDisplayValue = (fieldData, displayNames = [], excessNames = []) => {
    return this.getDisplayAndExcessNames(fieldData, displayNames, excessNames, false);
  }

  getOutOfStockDisplayValue = (fieldData, displayNames = [], excessNames = []) => {
    const { resource, subResource } = this.props.match.params;
    const { locations, isFromCreateEditModifier } = this.props;
    if (fieldData === false) return 'NO';
    if (!Array.isArray(fieldData) || !Array.isArray(locations)) return '';
    if (fieldData.length === 0) return 'NO';
    if (locations.length === fieldData.length) return 'All Locations';

    let names = [];
    if (resource === 'menu') {
      names = fieldData.map((locationId, ind, arr) => {
        const locationInfo = locations.find(location => `${location.id}` === `${locationId}`);
        if (!locationInfo || !locationInfo.name) return '';
        return locationInfo.name;
      });
    }
    if ((resource === 'options') || (resource === 'customizations' && subResource === 'options') || isFromCreateEditModifier) {
      return this.getDisplayAndExcessNames(fieldData, displayNames, excessNames, false);
    }
    const filteredEmptyValuesOut = names.filter(name => !!(name));
    return filteredEmptyValuesOut.join('\n\r');
  }

  getDisplayValueInStringFormat = (displayNames, excessNames, displayValues, excessCount) => {
    if (excessCount > 0) {
      excessNames = excessNames.join(', ');
      return displayNames.join(', ');
    }
    return (!Array.isArray(displayValues)) ? displayValues : displayValues.join(', ');
  };

  showDropdownListValues = (fieldData, fieldKey) => {
    let displayNames = [];
    let excessNames = [];
    let displayValues = fieldKey === 'customizations' ? this.getModifierDisplayValue(fieldData, displayNames, excessNames) : this.getOutOfStockDisplayValue(fieldData, displayNames, excessNames);
    const excessCount = excessNames.length;
    displayValues = this.getDisplayValueInStringFormat(displayNames, excessNames, displayValues, excessCount);
    return {
      displayValues, excessCount, excessNames,
    };
  }

  renderDropdownListWithExcessCount = (displayValues, excessNames, excessCount) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography component='div'>
          {displayValues}
          {' ... '}
          <Tooltip title={`${excessNames}`} enterTouchDelay={0}>
            <span style={styles.excessCountCircle}>
              <Typography style={styles.excessCountText}>{`+${excessCount}`}</Typography>
            </span>
          </Tooltip>
        </Typography>
      </div>
    );
  }

  getFieldDataFromType = (fieldData, field) => {
    const { resource, subResource } = this.props.match.params;
    const stringKeys = [
      'component', 'customizationView',
      'posIntegration', 'paymentIntegration',
      'reportFrequency', 'actionType',
      'rewardType',
    ];
    if (fieldData === undefined || fieldData === null) return fieldData;
    switch (field.type) {
      case 'viewListWithQuantity':
        if (resource === 'orders' && subResource === 'items' && field.key === 'options' && Array.isArray(fieldData)) {
          const names = fieldData.map((optionOrSubItem) => {
            // subItem
            if (optionOrSubItem.hasOwnProperty('portion')) {
              const portionName = get(optionOrSubItem, 'portion.name', translation('OrderItems.pizzaHalvesNull'));
              const itemName = get(optionOrSubItem, 'productItem.name', translation('OrderItems.productItemNull'));
              return `${portionName} - ${itemName}`;
            }
            // option
            return `${titleCase(optionOrSubItem.name)} x ${optionOrSubItem.quantity}`;
          });
          return names.join('\n\r');
        }
        if (!Array.isArray(fieldData)) return '';
      case 'nameOnly':
        return titleCase(`${fieldData.attribute_value} ${fieldData.name}`);
      case 'boolean':
        if (['outOfStock', 'out-of-stock'].includes(field.key)) {
          const { locations } = this.props;
          if (Array.isArray(fieldData) && Array.isArray(locations)) {
            if (locations.length === 0) return 'No business locations yet';
            if (locations.length === 1) {
              return fieldData.length === 1 ? 'YES' : 'NO';
            }
          }
        }
        if (['exclusive', 'autoApply'].includes(field.key)) {
          if (fieldData) {
            return (
              <div style={styles.checkCircleSpacing}>
                <CheckCircle color="primary" />
              </div>
            );
          }
          return ' ';
        }
        return fieldData ? 'YES' : 'NO';
      case 'decimal':
        return parseFloat(fieldData).toFixed(2);
      case 'dropdown':
        if (field.key === 'maxQuantity') {
          return fieldData;
        }
        if (['outOfStock', 'out-of-stock', 'outOfStockLocations'].includes(field.key) || field.key === 'customizations') {
          const { displayValues, excessCount, excessNames } = this.showDropdownListValues(fieldData, field.key);
          return excessNames.length === 0 ? displayValues : this.renderDropdownListWithExcessCount(displayValues, excessNames, excessCount);
        }
        if (field.key === 'type' && this.props.match.params.subResource === 'restrictions') {
          return titleCase(fieldData);
        }
        if (stringKeys.includes(field.key)) {
          // This runs if the dropdown value is a STRING - converts "STRING" to "String"
          return fieldData.charAt(0).concat(fieldData.slice(1).toLowerCase());
        }
        return fieldData.name; // Runs if the dropdown value is an OBJECT
      default:
        return fieldData;
    }
  }

  /**
   * If fieldData is null, undefined, NaN, empty string (""), 0,
   * or false => show as N/A.
   */
  getEmptyValuesForField = (data, fieldKey) => {
    if (fieldKey === 'outOfStock' && data === '') return '';
    if (fieldKey === 'points' && data === 0) return '00';

    if (!data) {
      if (fieldKey === 'maxQuantity' && data === 0) return '0';
      return 'N/A';
    }

    return data;
  }

  /**
   * @description
   * render view more button as a row in the table for those resources that have pagination
   */
  renderViewMoreTableBodyRow = (rowData) => {
    const {
      buttonArray, fieldNames, viewMoreLoading, onClickViewMore, data, totalResource, isFiltersSameAsLastUsedFilters, resourceName, submitFilters,
    } = this.props;
    return (
      !(data.length - 1 >= totalResource)
      && (
        <TableRow key={rowData.id} style={{ height: '40px' }}>
          <TableCell
            key={rowData.id}
            colSpan={buttonArray ? fieldNames.length + 1 : fieldNames.length}
            style={styles.viewMoreTableCell}
          >
            {
              viewMoreLoading > 0
                ? 'Loading...'
                : (
                  <ViewMoreRow
                    onClickViewMore={onClickViewMore}
                    rowData={rowData}
                    isFiltersSameAsLastUsedFilters={isFiltersSameAsLastUsedFilters}
                    resourceName={resourceName}
                    submitFilters={submitFilters}
                  />
                )
            }
          </TableCell>
        </TableRow>
      )
    );
  }

  getRowHeightAndColor = (rowData, dataIndex, bandedTable, isTablet) => {
    if (Object.keys(rowData).includes('coordinates')) {
      return styles.lightTableRowWithMapComponentHeight;
    }
    if (bandedTable && dataIndex % 2 === 0) return styles.bandedTableLightTableRow;
    if (bandedTable) return styles.bandedTableDarkTableRow;
    if (!bandedTable && !isTablet) return styles.v1TableRow;
    if (isTablet) return styles.tabletTableRowHeight;
  }

  shouldWrapIfNewlineCharsPresent = (rowData, field) => {
    const isProductListRestriction = rowData.type && ['CATEGORY', 'EXCLUDE_CATEGORY', 'PRODUCT', 'EXCLUDE_PRODUCT', 'PRODUCT_ITEM', 'EXCLUDE_PRODUCT_ITEM'].includes(rowData.type);
    const { shouldWrapNewLines } = field;

    return isProductListRestriction || shouldWrapNewLines;
  }

  getCellHeightAndStyle = (rowData, isSmallTable, field, index, isTablet) => {
    const { bandedTable, match } = this.props;
    const paddingLeft = bandedTable && index === 0 ? '16' : '10';
    const paddingStyles = {
      tabletStyle: '30px 10px 30px 10px',
      smallTableStyle: '0 15px 0 5px',
      defaultPadding: `20px 50px 20px ${paddingLeft}px`,
    };
    const getPaddingTypeStyle = (isTablet, isSmallTable) => {
      if (isTablet) {
        return paddingStyles.tabletStyle;
      } else if (isSmallTable) {
        return paddingStyles.smallTableStyle;
      } else {
        return paddingStyles.defaultPadding;
      }
    };
    const normalCell = {
      fontFamily: 'Lato',
      fontSize: '14px',
      color: '#000',
      borderBottom: bandedTable ? 'none' : '2px solid #f2f2f2',
      padding: getPaddingTypeStyle(isTablet, isSmallTable),
    };
    
    if (index == 0) {
      normalCell.cursor = 'pointer';
    }

    if (this.shouldWrapIfNewlineCharsPresent(rowData, field)) {
      // 'pre' for 'pre-formatted' makes newlines show up for text in <td> elements
      normalCell.whiteSpace = 'pre-wrap';
      return normalCell;
    } else {
      return normalCell;
    }
  }

  checkIsAdminUser = () => {
    const { admin } = this.props;
    if (!admin || !admin.email) return;
    const craverStaffAddress = /@admin\.com$/;
    return craverStaffAddress.test(admin.email);
  }

  renderDeleteButton = (rowData, dataIndex) => {
    return <MenuItem onClick={() => this.onClickDelete(rowData, dataIndex)}>Delete</MenuItem>;
  }

  // This method will be further refactored during next refactor ticket.
  getPrepareDisplayValuesMap = () => {
    const map = new Map();
    map.set((resource, resourceName, subResource, rowData, field) => (resourceName === 'tiers' && field.key === 'productItems' && rowData.rewardType === rewardTypes.DOLLAR), this.makeFieldDataNull);
    return map;
  }

  /**
   * @param rowData data object of each row
   * @param dataIndex index of each row
   * @description
   * render each row in a table, used by all resources
   */
  renderTableBodyRow = (rowData, dataIndex) => {
    const { anchorEl, isMenuOpen } = this.state;
    const {
      fieldNames,
      buttonArray,
      resourceName,
      viewOnly,
      data,
      isSmallTable,
      match,
      admin,
      bandedTable,
      isTablet,
      children: AdditionalMenuItems,
      showAdditionalLocationMenuItems,
    } = this.props;
    const { cloneElement } = React;
    const { resource, subResource } = match.params;
    const open = Boolean(isMenuOpen[dataIndex]);
    const ifTabletCellPadding = isTablet ? '20px 10px 20px 10px' : '20px 50px 20px 10px';
    const tableCellStyle = {
      ...styles.mainTableCell,
      padding: isSmallTable ? '0 15px 0 5px' : ifTabletCellPadding,
    };
    const tableButtonStyle = {
      ...tableCellStyle,
      position: 'relative',
      padding: '0',
    };
    const tableButtonStyleOptions = {
      ...tableButtonStyle,
      borderBottomRightRadius: '5px',
      borderTopRightRadius: '5px',
    };
    if (rowData.blurDisplay) {
      tableCellStyle.color = '#9b9b9b';
    }
    const correctAttemptedDeleteName = checkIsLocationAdmin(admin) ? 'deleteAsLocationAdmin' : 'delete';

    return (
      <TableRow key={rowData.id} style={this.getRowHeightAndColor(rowData, dataIndex, bandedTable, isTablet)}>
        {
          fieldNames.map((field, index) => {
            let fieldData = this.getFieldDataFromType(rowData[field.key], field);
            let allPossibleArgsNeeded = {
              rowData, fieldData, field, admin, resource, data, subResource,
            };
            if (field.key === 'totalPrice') {
              let totalAmountAfterDiscount = this.getFieldDataFromType(rowData[field.key], field) - rowData.totalRedeemedAmount;
              fieldData = showTwoDecimalsForMoney(totalAmountAfterDiscount);
            }

            this.prepareDisplayValuesMap.forEach((valFunc, keyFunc) => {
              if (!!keyFunc(resource, resourceName, subResource, rowData, field)) fieldData = valFunc(allPossibleArgsNeeded);
              allPossibleArgsNeeded = {
                rowData, fieldData, field, admin, resource, data, subResource,
              };
            });
            fieldData = this.getEmptyValuesForField(fieldData, field.key, rowData);

            return (
              !field.hideInDisplay
              && (
                <TableCell
                  style={this.getCellHeightAndStyle(rowData, isSmallTable, field, index, isTablet)}
                  onClick={() => this.onClickRowSelection(rowData.id, index)}
                  key={field.key + rowData.id}
                >
                  {fieldData}
                  {
                    (index === 0 && rowData.hasWarning)
                    && (
                      <Tooltip title='Please add one or more Product Items to make this Product visible in the app.'>
                        <Icon color="error" style={{ verticalAlign: 'middle' }}>
                          warning
                        </Icon>
                      </Tooltip>
                    )
                  }
                </TableCell>
              )
            );
          })
        }
        {
          (buttonArray || !viewOnly)
          && (
            <TableCell
              key={`iconButton${rowData.id}`}
              style={resourceName !== 'options' ? tableButtonStyle : tableButtonStyleOptions}
            >
              <div style={styles.checkboxAndThreeDotsMenuContainer}>
                <IconButton
                  style={styles.threeDotsIconButton}
                  onClick={event => this.handleMenuOpen(event, dataIndex)}
                >
                  <MoreVert />
                </IconButton>
                <Menu
                  id={rowData.id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={() => this.handleMenuClose(dataIndex)}
                >
                  {
                    checkIsAuthorized(admin, resource, this.getSubResouce(), 'edit')
                    && (
                      <MenuItem
                        style={styles.editOption}
                        onClick={() => this.onClickEdit(rowData, dataIndex)}
                      >
                        Edit
                      </MenuItem>
                    )
                  }
                  {
                    checkIsAuthorized(admin, resource, this.getSubResouce(), 'add')
                    && resource !== 'tiers'
                    && <MenuItem onClick={() => this.onClickDuplicate(rowData, dataIndex)}>Duplicate</MenuItem>
                  }
                  {
                    (checkIsAuthorized(admin, resource, this.getSubResouce(), correctAttemptedDeleteName)
                      && this.renderDeleteButton(rowData, dataIndex))
                  }
                  {AdditionalMenuItems && cloneElement(AdditionalMenuItems, { rowData, dataIndex })}
                  {
                    showAdditionalLocationMenuItems
                    && (
                      <AdditionalLocationMenuItems
                        {...this.props}
                        rowData={rowData}
                        handleMenuClose={() => this.handleMenuClose(dataIndex)}
                      />
                    )
                  }
                </Menu>
              </div>
            </TableCell>
          )
        }
      </TableRow>
    );
  }

  getSubResouce = () => {
    const { match } = this.props;
    const { subResource } = match.params;
    return subResource;
  }

  /**
   * render table head
   */
  renderTableHeader = () => {
    const {
      fieldNames,
      bandedTable,
      isTablet,
    } = this.props;
    return (
      <TableRow key="header" style={{ height: '40px' }}>
        {fieldNames.map((field, index) => !field.hideInDisplay
          && (
            <TableCell variant="head" style={this.getHeaderCellStyle(index, bandedTable, isTablet)} key={field.key}>
              {field.title.toUpperCase()}
            </TableCell>
          ))}
      </TableRow>
    );
  }

  getHeaderCellStyle = (index, bandedTable, isTablet) => {
    if (bandedTable) return index === 0 ? styles.bandedTableFirstHeadCellCenteredText : styles.bandedTableHeadCellCenteredText;
    if (isTablet) return styles.tableHeadCellTablet;
    return styles.tableHeadCell;
  }

  handleMenuOpen = (event, index) => {
    this.setState({ anchorEl: event.currentTarget });
    this.state.isMenuOpen[index] = true;
  }

  handleMenuClose = (index) => {
    this.setState({ anchorEl: null });
    this.state.isMenuOpen[index] = false;
  }

  makeFieldDataNull = ({ fieldData }) => {
    fieldData = 'N/A';
    return fieldData;
  }

  renderTableBodyContent = () => {
    const { data } = this.props;
    return (
      data.map((rowData, index) => {
        if (rowData.id === 'viewMore') {
          return this.renderViewMoreTableBodyRow(rowData);
        } else {
          return this.renderTableBodyRow(rowData, index);
        }
      })
    );
  }

  onCloseDialog = () => {
    this.setState({ isDeleteConfirmDialogOpen: false, isBulkActionConfirmDialogOpen: false });
  }

  onClickConfirmDeleteButton = async () => {
    const {
      actions, apiToken, match, onClickDeleteResource,
    } = this.props;
    const {
      resource
    } = match.params;
    const data = this.state.dataInDeleteConfirmDialog;
    actions.clearErrors();

    if (typeof onClickDeleteResource === 'function') {
      onClickDeleteResource(data.id);
    } else if (resource === 'locations') {
      data.isDeleted = true;
      actions.updateResource(apiToken, data, resource, data.id);
    } else {
      actions.deleteResource(apiToken, resource, data.id);
    }

    this.onCloseDialog();
  }

  /**
   * @description
   * determine table height base on conditions
   */
  tableHeightCalculator = () => {
    const {
      viewOnly,
      isSmallTable,
      admin,
      match,
      isSeparateToolbar,
    } = this.props;
    const { resource } = match.params;
    let height = '';

    const shouldShowAddResourceButtonForSmallTable = checkIsAuthorized(admin, resource, this.getSubResouce(), 'add');
    if (!viewOnly && !isSmallTable) {
      height = '85%'; // for resource table that come with a toolbar, e.g users, locations
    } else if (viewOnly && !isSmallTable) {
      height = '100%'; // for resource table without toolbar, only for orders
    } else if (isSmallTable && shouldShowAddResourceButtonForSmallTable) {
      height = '60%'; // for three small resource tables in menu page, e.g categories, customizations, taxes
    } else if (isSmallTable && !shouldShowAddResourceButtonForSmallTable) {
      height = '80%';
    }
    if (isSeparateToolbar) {
      height = '100%';
    }
    return height;
  }

  tableRootStyles = () => {
    const { resourceName, bandedTable, isTablet } = this.props;
    const { hideToolbar } = this.props;
    if (resourceName === 'orderItems') return { ...viewStyles.tableRootContainer, height: 'auto' };
    if (bandedTable) return styles.bandedTableRootContainer;
    if (isTablet) return { ...styles.tableRootContainerTablet, height: this.tableHeightCalculator() };
    if (resourceName === 'options') {
      if (hideToolbar) return { ...styles.optionsOnModifierTableRoot, height: this.tableHeightCalculator() };
      return { ...styles.tableRootContainerOptions, height: this.tableHeightCalculator() };
    }
    return { ...styles.tableRootContainer, height: this.tableHeightCalculator() };
  }

  getTargetResourceNames = (action) => {
    const { isDeleteConfirmDialogOpen, dataInDeleteConfirmDialog } = this.state;
    if (action === 'delete' && isDeleteConfirmDialogOpen) return dataInDeleteConfirmDialog.name || dataInDeleteConfirmDialog.title;

    return '';
  }

  render() {
    const { data, hideToolbar, resourceName } = this.props;
    return (
      !data
        ? <LoadingBar />
        : (
          <Fragment>
            <div style={this.tableRootStyles()}>
              <Table>
                <TableHead style={styles.tableHead}>
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody style={styles.tableBody}>
                  {this.renderTableBodyContent()}
                </TableBody>
              </Table>
            </div>
            <DeleteConfirmDialog
              resourceName={resourceName}
              isDialogOpen={this.state.isDeleteConfirmDialogOpen}
              deleteDataName={this.getTargetResourceNames('delete')}
              onCloseDialog={this.onCloseDialog}
              onClickConfirmButton={this.onClickConfirmDeleteButton}
            />
          </Fragment>
        )
    );
  }
}

ResourceList.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  buttonArray: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  fieldNames: PropTypes.arrayOf(PropTypes.object).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  hideToolbar: PropTypes.bool,
  isSmallTable: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  onClickViewMore: PropTypes.func,
  onClickEditResource: PropTypes.func,
  onClickDeleteResource: PropTypes.func,
  resourceName: PropTypes.string.isRequired,
  totalResource: PropTypes.number,
  viewMoreLoading: PropTypes.number,
  viewOnly: PropTypes.bool,
};

ResourceList.defaultProps = {
  buttonArray: null,
  data: null,
  isSmallTable: false,
  onClickDeleteResource: null,
  onClickEditResource: null,
  onClickViewMore: null,
  viewMoreLoading: 0,
  viewOnly: false,
  totalResource: 0,
};

const mapStateToProps = (state, props) => ({
  locations: getLocations(state),
  admin: getAdmin(state),
  pageSettings: getPageSettings(state),
});

const pipeline = flowRight([withStyles(displayResourceStyles), withRouter, connect(mapStateToProps)]);
export default pipeline(ResourceList);
